module.exports = __webpack_public_path__ + "img/underground_electrical_fault.79aa7d03.svg";